import { Helmet } from 'react-helmet-async';
import telegram from './img/telegram.png';
import whatsapp from './img/whatsapp.png';
import instagram from './img/instagram.png';
import web from './img/web.png';
import aiimage from './img/aibrain.png';
import aigirl from './img/logo.png';
import Pricing from './Pricing';
import About from './About';
import chat from './img/chat.gif';

function Home() {
  return (
    <>
      <Helmet>
        <title>ИИ-Менеджер для Продаж 24/7 | Рост конверсии до 200%</title>
        <meta name="description" content="ИИ-консультант для вашего бизнеса: автоматизация продаж, интеграция с CRM, Telegram, WhatsApp. Сократите затраты на сотрудников и увеличьте конверсию!" />
        <meta name="keywords" content="ИИ менеджер, автоматизация продаж, CRM интеграция, Telegram, WhatsApp, повышение конверсии" />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta charSet="UTF-8" />
        <meta name="author" content="ИИ Консультант" />
        <meta property="og:title" content="ИИ-Менеджер для Продаж 24/7" />
        <meta property="og:description" content="Автоматизируйте продажи с ИИ-консультантом: работает 24/7, интегрируется с Telegram, WhatsApp, сайтом и CRM. Сократите затраты и увеличьте конверсию до 200%!" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ailink.services" />
        <meta property="og:image" content="/images/ai-consultant.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="ИИ-Менеджер для Продаж 24/7" />
        <meta name="twitter:description" content="ИИ-консультант для автоматизации продаж. Интеграция с CRM, Telegram, WhatsApp. Экономия до 50% на сотрудниках!" />
        <meta name="twitter:image" content="/images/ai-consultant.jpg" />
        <link rel="canonical" href="https://ailink.services" />
      </Helmet>

      <section className="section">
        <div className="container"> 
      
          <h2>Почему ИИ-консультант отличное решение?</h2>
                  <div className="main-image">
            <img style={{}} src={aiimage} alt="Brain" width="330" height="330"/>
          </div>
        
         <a href='https://t.me/sofiya_cosmetic' className="button ai" >
              Чат с ИИ
        </a>
          
         <p style={{ fontSize: '22px' , animation: 'zoom 5s infinite'}}>Рост конверсии до 230%</p>
          <h2>Заменит отдел продаж — 24/7</h2>


                    <h4>Сократит затраты на сотрудников от 50% и повышает конверсию за счёт непрерывных ответов</h4>

             
          <p style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
            Отвечает всем и мгновенно, время ответа составляет от 0.3-2 сек.
            Автоматически ведёт учёт клиентов в вашей CRM (Битрикс, amoCRM).
          </p>
          
                    <div className="contact-links">
            <a href="https://t.me/ailink_services" className="button telegram">Заказать в Telegram</a>
            <a href="https://wa.me/4917645150900" className="button whatsapp">Заказать в WhatsApp</a>

          </div>
  
        </div>
      </section>



      <section className="section">
        <h2>Как это работает?</h2>
        <ol className="steps">
   <li>
     <strong> 1. Ai-консультант получает обращения от 
              клиентов </strong>
            <p> Специально разработанный ИИ-сотрудник получает обращения от 
              клиентов через выбранный канал для связи: Telegram, WhatsApp, Instagram, сайт</p>
       </li>
          
      <section className="section">
        <div className="channels">
          <div className="channel-card">
            <img src={telegram} alt="Telegram" width="50" height="50" />
          </div>
          <div className="channel-card">
            <img src={whatsapp} alt="WhatsApp" width="50" height="50" />
          </div>
          <div className="channel-card">
            <img src={instagram} alt="Instagram" width="50" height="50" />
          </div>
          <div className="channel-card">
            <img style={{}} src={web} alt="Website" width="50" height="50"/>
          </div>
        </div>
      </section>


          <li style={{display:'flex', flexDirection:'column'}}>
            <strong>2. ИИ консультант анализирует запрос и подбирает лучшие варианты предложений</strong>
            <p>На основе массива информации о ваших услугах или товарах нейросеть подбирает наилучший ответ.</p>
          </li>
                        <div className='chat-preview'>
      <img src={chat}alt="chat-preview" width='380px' style={{borderRadius:'40px'}}/>
      </div>
          <li style={{display:'flex', flexDirection:'column'}}>
            <strong>3. Даёт ответ и сохраняет данные</strong>
            <p>Автоматически сохраняет данные обращений в CRM (Битрикс, amoCRM).</p>
    
          </li>
        </ol>
        
      </section>

   

       <About/>
 
      <Pricing/>

            <section className="section">
        <h2>Установка</h2>
            <p>Установка ИИ менеджера происходит в течении 1-3 дней БЕСПЛАТНО.
               Настройка происходит удалённо, от Вас требуется только самый миимум.
               Круглосуточная техническая поддержка.
            </p>
      </section>


      <section className="section">

        <h3>Как ИИ-помощники трансформируют продажи и клиентский сервис в бизнесе</h3>
        <p>Внедрение искусственного интеллекта в бизнес становится не просто трендом, 
          а необходимостью для повышения эффективности и конкурентоспособности. 
          Особенно перспективным направлением является 
          использование ИИ-помощников, консультантов и продавцов. </p>
          <p> Такие системы способны моментально обрабатывать 
          большие объёмы информации, анализировать потребности клиентов и предлагать 
          персонализированные решения. Это сокращает время на обслуживание, 
          повышает точность рекомендаций и улучшает клиентский опыт. В результате бизнес 
          получает не только рост продаж, но и укрепление лояльности аудитории.</p>
      </section>


      <section className="section">
        <h2>Готовы автоматизировать продажи?</h2>
        <p>Свяжитесь с нами:</p>
         Email: servicesailink@gmail.com
     <div className="contact-links">
            <a href="https://t.me/ailink_services" className="button telegram">Заказать в Telegram</a>
            <a href="https://wa.me/4917645150900" className="button whatsapp">Заказать в WhatsApp</a>
    

          </div>
                 
      </section>
    </>
  );
}

export default Home;